import React, { useState, useEffect } from 'react';

const AiRewriteHistory = () => {
  const [history, setHistory] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);
  const [shareIndex, setShareIndex] = useState(null);
  const [copyMessage, setCopyMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [newName, setNewName] = useState('');
  const [editingNameIndex, setEditingNameIndex] = useState(null);

  useEffect(() => {
    const storedHistory = localStorage.getItem('history');
    if (storedHistory) {
      // Sort history from newest to oldest
      const parsedHistory = JSON.parse(storedHistory);
      setHistory(parsedHistory.reverse());
    }
  }, []);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleMenuToggle = (index) => {
    setMenuIndex(menuIndex === index ? null : index);
  };

  const handleDelete = (index) => {
    const confirmed = window.confirm('Weet je zeker dat je deze tekst wilt verwijderen?');
    if (confirmed) {
      const updatedHistory = history.filter((_, i) => i !== index);
      setHistory(updatedHistory);
      localStorage.setItem('history', JSON.stringify(updatedHistory));
      setMenuIndex(null);
    }
  };

  const handleShare = (index) => {
    setShareIndex(index);
  };

  const closeShareModal = () => {
    setShareIndex(null);
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        setCopyMessage(true);
        setTimeout(() => setCopyMessage(false), 2000);
      }).catch(err => {
        setErrorMessage('Failed to copy text: ' + err.message);
        setTimeout(() => setErrorMessage(''), 2000);
      });
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setCopyMessage(true);
        setTimeout(() => setCopyMessage(false), 2000);
      } catch (err) {
        setErrorMessage('Failed to copy text: ' + err.message);
        setTimeout(() => setErrorMessage(''), 2000);
      }
      document.body.removeChild(textArea);
    }
    closeShareModal();
  };

  const sendEmail = (text) => {
    const mailtoLink = `mailto:?subject=Gedeelde Tekst&body=${encodeURIComponent(text)}`;
    window.location.href = mailtoLink;
    closeShareModal();
  };

  const handleEditName = (index) => {
    setNewName(history[index].name || '');
    setEditingNameIndex(index);
  };

  const handleSaveName = () => {
    const updatedHistory = history.map((item, index) => index === editingNameIndex ? { ...item, name: newName } : item);
    setHistory(updatedHistory);
    localStorage.setItem('history', JSON.stringify(updatedHistory));
    setEditingNameIndex(null);
  };

  return (
    <div>
      <div className="banner-settings-wrapper">
        <h1>AI Rewrite History</h1>
        <div className="banner-settings-switch">
          <div className="banner-settings-inner-content">
            <div className="banner-settings-inner-content-details_input">
              <h5>Herschreven tekst historie</h5>
              <p>Bekijk de historie van de herschreven teksten.</p>
            </div>
          </div>
        </div>
        <div className="history">
          {history.length === 0 ? (
            <p>Geen herschreven teksten gevonden.</p>
          ) : (
            history.map((item, index) => (
              <div key={index} className="history-item" style={{ marginBottom: '10px' }}>
                <div onClick={() => handleToggle(index)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }}>
                    <p>{item.timestamp}{item.name && ` | ${item.name}`}</p>
                  </div>
                  <div className="menu-container" style={{ position: 'relative' }}>
                    <button onClick={() => handleMenuToggle(index)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                      &#x22EE;
                    </button>
                    {menuIndex === index && (
                      <div className="menu" style={{ position: 'absolute', right: 0, background: 'white', border: '1px solid #ccc', borderRadius: '4px', zIndex: 1 }}>
                        <button onClick={() => handleEditName(index)} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', border: 'none', background: 'none', cursor: 'pointer' }}>
                          <span className="material-icons" style={{ marginRight: '5px' }}>edit</span>
                        </button>
                        <button onClick={() => handleShare(index)} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', border: 'none', background: 'none', cursor: 'pointer' }}>
                          <span className="material-icons" style={{ marginRight: '5px' }}>share</span>
                        </button>
                        <button onClick={() => handleDelete(index)} style={{ color: 'red', display: 'flex', alignItems: 'center', padding: '5px 10px', border: 'none', background: 'none', cursor: 'pointer' }}>
                          <span className="material-icons" style={{ marginRight: '5px' }}>delete</span>
                        </button>

                      </div>
                    )}
                  </div>
                </div>
                {expandedIndex === index && (
                  <>
                    <hr style={{ margin: '10px 0' }} />
                    <div>
                      <p><strong>Oorspronkelijke tekst:</strong> {item.originalText}</p>
                      <p><strong>Prompt tekst:</strong> {item.promptText}</p>
                      <p onClick={() => copyToClipboard(item.rewrittenText)} style={{ cursor: 'pointer' }}>{item.rewrittenText}</p>
                    </div>
                  </>
                )}
              </div>
            ))
          )}
        </div>
        {shareIndex !== null && (
          <div className="share-modal" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', border: '1px solid #ccc', borderRadius: '4px', padding: '20px', zIndex: 2 }}>
            <h3>Delen</h3>
            <p>{history[shareIndex].rewrittenText}</p>
            <button onClick={() => copyToClipboard(history[shareIndex].rewrittenText)} style={{ margin: '10px', cursor: 'pointer' }}>Kopieer naar klembord</button>
            <button onClick={() => sendEmail(history[shareIndex].rewrittenText)} style={{ margin: '10px', cursor: 'pointer' }}>Exporteer naar email</button>
            <button onClick={closeShareModal} style={{ margin: '10px', cursor: 'pointer' }}>Sluiten</button>
          </div>
        )}
      </div>
      {copyMessage && (
        <div style={{ position: 'fixed', top: '130px', left: '50%', transform: 'translateX(-50%)', background: 'lightgreen', padding: '10px', borderRadius: '5px', zIndex: 3 }}>
          Copied to clipboard
        </div>
      )}
      {errorMessage && (
        <div style={{ position: 'fixed', top: '130px', left: '50%', transform: 'translateX(-50%)', background: 'lightcoral', padding: '10px', borderRadius: '5px', zIndex: 3 }}>
          {errorMessage}
        </div>
      )}
      {editingNameIndex !== null && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)', zIndex: 4 }}>
          <div className="modal" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', border: '1px solid #ccc', borderRadius: '4px', padding: '20px', zIndex: 5 }}>
            <h3>Geef een naam</h3>
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Geef een naam"
              style={{ marginBottom: '10px' }}
            />
            <div>
              <button onClick={handleSaveName} style={{ marginRight: '10px', cursor: 'pointer' }}>Opslaan</button>
              <button onClick={() => setEditingNameIndex(null)} style={{ cursor: 'pointer' }}>Annuleren</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiRewriteHistory;
